import { convertObjectNumbers } from 'Shared/Utils/Extensions/String/StringExtensions';
import { AxiosResponse } from 'axios';

import { apiInstanceType, onErrorType, onResultType } from '../Contracts/types';
import TrimJson from '../Utils/TrimJson';
import { ShowResponseError } from '../Utils/showResponseError';

export interface IHttpPutServiceProps {
  url: string;
  body?: object;
  onResult?: onResultType;
  onError?: onErrorType;
}

interface IProps extends IHttpPutServiceProps {
  API: apiInstanceType;
}

export const HttpPutService = async (props: IProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 201) {
        return res.data;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      ShowResponseError(error);
    };
  }

  try {
    const body = convertObjectNumbers(TrimJson(props.body, false));
    const response = await props.API.put(props.url, body).then(props.onResult).catch(props.onError);
    return response;
  } catch (error) {
    ShowResponseError(error);
  }
};
